import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AreaChart, ColumnChart } from '@/features/dashboard-charts';
import { DashboardFilterBar } from '@/features/dashboard-filters';
import { useStorageOverview } from '../lib/use-storage-overview';
import { PageHeader, ChartSection, TopListsGrid, MovementsStats, StockOnHandStats } from './components';

export function StorageOverviewPage() {
  const { t } = useTranslation();
  const { data, formattedStats, isLoading, error, options, updateOption } = useStorageOverview();

  if (error) {
    return (
      <div className="p-6">
        <Card className="p-6">
          <p className="text-destructive">Error loading storage overview data</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <PageHeader title={t('report_storageOverview_title', 'Storage Overview')} />

      <DashboardFilterBar variant="storage" options={options} onOptionChange={updateOption} />

      <Tabs defaultValue="movements" className="space-y-6">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="movements">Stock Movements</TabsTrigger>
          <TabsTrigger value="soh">Stock on Hand</TabsTrigger>
        </TabsList>

        <TabsContent value="movements" className="space-y-6">
          {data && (
            <>
              <MovementsStats stats={formattedStats} />
              <ChartSection>
                <ColumnChart data={data.warehouseMovements} height={400} loading={isLoading} />
              </ChartSection>
              <TopListsGrid topWarehouses={data.topWarehouses} topUsers={data.topUsers} isLoading={isLoading} />
            </>
          )}
        </TabsContent>

        <TabsContent value="soh" className="space-y-6">
          {data && (
            <>
              <StockOnHandStats stats={formattedStats} />
              <ChartSection>
                <AreaChart data={data.warehouseSOH} height={400} loading={isLoading} />
              </ChartSection>
              <TopListsGrid topWarehouses={data.topWarehouses} topUsers={data.topUsers} isLoading={isLoading} />
            </>
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
}
